/*
 * @Description:
 * @Autor: yd
 * @Date: 2020-07-02 11:21:57
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2025-03-12 17:10:17
 */
//文件管理
import http from '../httpConfig'
import axios from 'axios'
const table = 'mrbase_sys_attachments'
//文件新增 上传
export const addFile = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.post('/api/awsS3FileManager/add-file-record-plan/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
//文件新增结果回调 
export const addResultFile = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.post('/api/awsS3FileManager/add-file-callback/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}



//文件记录-删除准备（状态修改）
export const deleteFile = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.post('/api/awsS3FileManager/del-file-record-plan/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


//文件记录-删除结果回调
export const deleteResultFile = (params = {}) => {
  return new Promise((resolve, reject) => {
    http.post('/api/awsS3FileManager/del-file-callback/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

